import { render, staticRenderFns } from "./CallLogs.vue?vue&type=template&id=962c507e&scoped=true"
import script from "./CallLogs.vue?vue&type=script&lang=js"
export * from "./CallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962c507e",
  null
  
)

export default component.exports